import React, {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {ActionDialogProps} from "../../../components/ActionMenu/ActionMenu";
import Button from "../../../components/buttons/Button";


const DeleteListEntityActionFabric = ({id, loadEntitiesFn, deleteEntityFn, entity}: {
    id: string;
    loadEntitiesFn: () => Promise<void>;
    deleteEntityFn: () => Promise<void>;
    entity: any;
}) => {
    const DeleteListEntityAction: React.FC<ActionDialogProps> = ({
                                                                     handleCloseDialog
                                                                 }: ActionDialogProps) => {
        const [blocked, setBlocked] = useState<boolean>(false);
        const {t} = useTranslation();

        const classes = classNames(
            blocked && 'disabled'
        )

        const cancelHandler = useCallback((event) => {
            handleCloseDialog(event);
        }, [handleCloseDialog])

        const deleteHandler = useCallback(async () => {
            setBlocked(true);
            await deleteEntityFn();
            setBlocked(false);
            handleCloseDialog(event);
        }, [handleCloseDialog, deleteEntityFn])

        return (
            <div className={classes} style={{display: 'flex', gap: '10px'}}>
                <Button
                    onClick={cancelHandler}
                    text={t("common.cancel")}
                    colorType="transparent"
                />
                <Button
                    type="submit"
                    onClick={deleteHandler}
                    text={t("common.delete")}
                    colorType="dark"
                    testId="deleteConfirmationModalDeleteBtn"
                />
            </div>
        )
    }

    return DeleteListEntityAction
}

export default DeleteListEntityActionFabric;